var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYellowBag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 61,
    viewBox: "0 0 50 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.98552 13.6826L38.7683 14.528L34.662 60.1804H0L3.98552 13.6826Z",
    fill: "#FEE611"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.41 14.2861L49.9994 60.3008H34.2988L38.6467 14.6485L45.41 14.2861Z",
    fill: "#D6C000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7148 14.4066L12.4395 9.21338C12.8018 6.47585 15.4347 1.04909 23.0675 1.24233C25.7648 1.44364 31.2318 3.53707 31.5217 10.3004V14.4066",
    stroke: "#FEE611"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5266 14.5278L39.1305 9.93838C39.0499 6.91905 36.7633 0.904531 28.2608 1.00115C25.5233 1.16217 19.8309 3.17505 18.9613 9.93838L18.3574 14.5278",
    stroke: "#D6C000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowBag);
export default __webpack_public_path__ + "static/media/yellow-bag.ef4cae3f3cc2119ff7247db97c7970c9.svg";
export { ForwardRef as ReactComponent };